/**
 * ContextBadge — Badge contextuel flottant sur la caméra
 *
 * Fond pill semi-opaque, texte blanc cassé.
 * Accessible via aria-live pour annoncer les changements d'état
 * aux lecteurs d'écran (ex: "Identification en cours…").
 *
 * Props :
 *   text {string} — texte affiché (ex: 'Pointez une œuvre')
 */

import React from 'react'
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion'

const ContextBadge = ({ text = 'Pointez une œuvre' }) => {
  const prefersReduced = useReducedMotion()

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={text}
        role="status"
        aria-live="polite"
        initial={{ opacity: 0, y: 4 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -4 }}
        transition={{ duration: 0.2 }}
        style={{
          display:       'inline-flex',
          alignItems:    'center',
          gap:           '8px',
          padding:       '8px 18px',
          borderRadius:  '9999px',
          background:    'rgba(26,29,36,0.85)',
          backdropFilter:'blur(4px)',
        }}
      >
        {/* Indicateur dot animé pendant scanning */}
        {text.includes('cours') && (
          <motion.span
            style={{
              display:      'inline-block',
              width:        '6px',
              height:       '6px',
              borderRadius: '50%',
              background:   '#B08D5B',
              flexShrink:   0,
            }}
            animate={prefersReduced ? { opacity: 1 } : { opacity: [1, 0.3, 1] }}
            transition={prefersReduced ? { duration: 0 } : { duration: 0.9, repeat: Infinity, ease: 'easeInOut' }}
            aria-hidden="true"
          />
        )}
        <span
          style={{
            fontFamily:    "'Atkinson Hyperlegible', system-ui, sans-serif",
            fontSize:      '13px',
            fontWeight:    400,
            color:         '#F8F4EC',
            letterSpacing: '0.3px',
            whiteSpace:    'nowrap',
          }}
        >
          {text}
        </span>
      </motion.div>
    </AnimatePresence>
  )
}

export default ContextBadge
